import { type Registry as Services, service } from '@ember/service';
import Component from '@glimmer/component';
import { PrismRadioGroup } from '@mylighthouse/prism-ember';
import { t } from 'ember-intl';
import { eq } from 'ember-truth-helpers';

interface HotelAndMarketRatesExportModalExportRadioButtonsSignature {
  Args: {
    selectedDays: unknown;
    setSelectedDays: unknown;
  };
}

export default class HotelAndMarketRatesExportModalExportRadioButtons extends Component<HotelAndMarketRatesExportModalExportRadioButtonsSignature> {
  @service('hotel-and-market')
  declare hotelAndMarketService: Services['hotel-and-market'];

  exportDayOptions = null;

  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  get exportOptions() {
    return this.hotelAndMarketService.hotel
      ? [60, 90, 120, 'custom']
      : [60, 90, 'custom'];
  }

  <template>
    <div class="flex flex-col gap-400">
      <p class="text-300--bold">
        {{t "rates.export.timeframe_title"}}
      </p>
      <PrismRadioGroup
        @name="custom-export-preselected-days-radio-group"
        {{! @glint-expect-error: Incorrect type }}
        @onChange={{@setSelectedDays}}
        {{! @glint-expect-error: Incorrect type }}
        @value={{@selectedDays}}
        class="ic-product-tour-custom-export-preselection-options"
        as |RadioGroup|
      >
        {{#each this.exportOptions as |exportOption|}}
          <RadioGroup.input
            {{! @glint-expect-error: Incorrect type }}
            @value={{exportOption}}
            data-event-id="custom-export-preselected-days-changed"
            data-event-value={{exportOption}}
          >
            {{#if (eq exportOption "custom")}}
              {{t "rates.custom"}}
            {{else}}
              {{t "general.next_days" count=exportOption}}
            {{/if}}
          </RadioGroup.input>
        {{/each}}
      </PrismRadioGroup>
    </div>
  </template>
}
